
define('text!templates/modules/calendar/animated-session/session/session-week-content.html',[],function () { return '<div class="alert-list"></div>\n<div class="item-stats"></div>\n<div class="session-notes info-section">\n    <div class="form-section">\n        <span data-bind="markdown:session_notes"></span>\n    </div>\n</div>\n<div id="session-week-list"></div>\n';});

